module.exports = __webpack_public_path__ + "img/icon-question-arrow-left-blue.e4729eea.svg";